var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 22.5C41.25 12.1447 32.8553 3.75 22.5 3.75C12.1447 3.75 3.75 12.1447 3.75 22.5C3.75 31.8585 10.6066 39.6156 19.5703 41.0222V27.9199H14.8096V22.5H19.5703V18.3691C19.5703 13.6699 22.3696 11.0742 26.6525 11.0742C28.7032 11.0742 30.8496 11.4404 30.8496 11.4404V16.0547H28.4853C26.1562 16.0547 25.4297 17.5001 25.4297 18.9844V22.5H30.6299L29.7986 27.9199H25.4297V41.0222C34.3934 39.6156 41.25 31.8585 41.25 22.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.9c6f82311166e742b1b1e2b20c28f877.svg";
export { ForwardRef as ReactComponent };